import React, { useState } from 'react';
import { AppBar, Tabs, Tab } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import TabPanel from '../../components/TabPanel';
import Providers from './components/Providers';
import Practices from './components/Practices';
import Insurances from './components/Insurances';
import Specialties from './components/Specialties';
import Cities from './components/Cities';
import Reviews from './components/Reviews';
import ImportPatients from './components/ImportPatients';
import RecurringAvailability from './components/RecurringAvailability';
import AppointmentDurationRules from '../../components/AppointmentDurationRules';
import ProviderUrl from './components/ProviderUrl';
import BlogContent from './components/BlogContent';
import PressContent from './components/PressContent';
import ActivityReports from './components/ActivityReports'

function ProviderAdminSuperAdmin(props) {
  const {
    classes: { root, header, headerText, appBar },
  } = props;

  const [tabPosition, changeTabPosition] = useState(0);

  const handleTabPositionChange = (event, newTabPosition) => {
    changeTabPosition(newTabPosition);
  };

  return (
    <div className={root}>
      <header className={header}>
        <h2 className={headerText}>Super Admin</h2>
      </header>

      <AppBar position="static" color="default" classes={{ root: appBar }}>
        <Tabs
          value={tabPosition}
          onChange={handleTabPositionChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          <Tab label="Providers" />
          <Tab label="Practices" />
          <Tab label="Insurances" />
          <Tab label="Specialties" />
          <Tab label="Cities" />
          <Tab label="Reviews" />
          <Tab label="Import Patients" />
          <Tab label="Recurring Availability" />
          <Tab label="Appointment Duration" />
          <Tab label="Provider Url" />
          <Tab label="Blog Content" />
          <Tab label="Press Content" />
          <Tab label="Activity Reports" />
        </Tabs>
      </AppBar>

      {tabPosition === 0 && (
        <TabPanel value={'providers'}>
          <Providers value={'providers'} />
        </TabPanel>
      )}

      {tabPosition === 1 && (
        <TabPanel>
          <Practices />
        </TabPanel>
      )}

      {tabPosition === 2 && (
        <TabPanel>
          <Insurances />
        </TabPanel>
      )}

      {tabPosition === 3 && (
        <TabPanel>
          <Specialties />
        </TabPanel>
      )}

      {tabPosition === 4 && (
        <TabPanel>
          <Cities />
        </TabPanel>
      )}
      {tabPosition === 5 && (
        <TabPanel>
          <Reviews />
        </TabPanel>
      )}
      {tabPosition === 6 && (
        <TabPanel>
          <ImportPatients />
        </TabPanel>
      )}
      {tabPosition === 7 && (
        <TabPanel>
          <RecurringAvailability />
        </TabPanel>
      )}
      {tabPosition === 8 && (
        <TabPanel>
          <AppointmentDurationRules />
        </TabPanel>
      )}
      {tabPosition === 9 && (
        <TabPanel>
          <ProviderUrl />
        </TabPanel>
      )}

      {tabPosition === 10 && (
        <TabPanel>
          <BlogContent />
        </TabPanel>
      )}

      {tabPosition === 11 && (
        <TabPanel>
          <PressContent />
        </TabPanel>
      )}

      {tabPosition === 12 && (
        <TabPanel>
          <ActivityReports />
        </TabPanel>
      )}
    </div>
  );
}

const styles = () => ({
  root: {
    padding: '3em',
  },
  appBar: {
    zIndex: 10,
  },
  header: {
    paddingBottom: '3em',
  },
  headerText: {
    fontWeight: 'normal',
    fontSize: '1.8em',
    lineHeight: '19px',
    color: '#1C1C1C',
  },
});

export default withStyles(styles)(ProviderAdminSuperAdmin);
